import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TPpwrApi } from './types';

export const ppwr: TPpwrApi = {
	getPackingTypes: () => http.get(endpoint.ppwr.PACKING_TYPES).then((response) => response.data),
	updatePackingTypeWeight: (payload) =>
		http
			.post(endpoint.ppwr.PACKING_TYPE_WEIGHT(payload.packingTypeId), {
				weight: payload.weight,
				weightProductPack: payload.weightProductPack,
			})
			.then((response) => response.data),
	updatePackingTypeEnabled: (payload) =>
		http
			.post(endpoint.ppwr.PACKING_TYPE_ENABLED(payload.packingTypeId), {
				enabled: payload.enabled,
			})
			.then((response) => response.data),
	uploadProofDocument: (payload) =>
		http
			.post(endpoint.ppwr.UPLOAD_PROOF_DOCUMENT(payload.packingTypeId), payload.file)
			.then((response) => response.data),
	deleteProofDocument: (documentId) =>
		http.delete(endpoint.ppwr.PROOF_DOCUMENT(documentId)).then((response) => response.data),
	downloadProofDocument: (documentId) =>
		http
			.get(endpoint.ppwr.PROOF_DOCUMENT(documentId), { responseType: 'blob' })
			.then((response) => response.data),
	getCountryExclusions: () =>
		http.get(endpoint.ppwr.COUNTRY_EXCLUSIONS).then((response) => response.data),
	createCountryExclusion: (payload) =>
		http.post(endpoint.ppwr.COUNTRY_EXCLUSIONS, payload).then((response) => response.data),
	updateCountryExclusion: (payload) =>
		http
			.put(endpoint.ppwr.COUNTRY_EXCLUSION(payload.id), payload.body)
			.then((response) => response.data),
	getManualReporting: (payload) =>
		http.post(endpoint.ppwr.MANUAL_REPORTING, payload).then((response) => response.data),
	upsertManualReport: (payload) =>
		http.post(endpoint.ppwr.MANUAL_REPORTING_UPSERT, payload).then((response) => response.data),
};
